import { useState } from 'react';
import type { ClaudeCodeConnectionData } from '@/shared/types/workspace';
import { useDisconnectClaudeCode } from './use-disconnect-claude-code';

export type ClaudeCardMode = 'view' | 'form' | 'confirm';

type UseClaudeCodeCardResult = {
  mode: ClaudeCardMode;
  isSaved: boolean;
  isConnected: boolean;
  isRejected: boolean;
  isOff: boolean;
  isDisconnecting: boolean;
  openForm: () => void;
  closeForm: () => void;
  onSaved: () => void;
  askDisconnect: () => void;
  keepConnected: () => void;
  disconnect: () => Promise<void>;
};

export function useClaudeCodeCard(connection: ClaudeCodeConnectionData): UseClaudeCodeCardResult {
  const [mode, setMode] = useState<ClaudeCardMode>('view');
  const [isSaved, setIsSaved] = useState(false);
  const { disconnectClaudeCode, isDisconnecting } = useDisconnectClaudeCode();

  const disconnect = async () => {
    await disconnectClaudeCode();
    setMode('view');
  };

  return {
    mode,
    isSaved: isSaved && mode === 'view',
    isConnected: connection.status === 'CONNECTED',
    isRejected: connection.status === 'KEY_REJECTED',
    isOff: connection.status === 'NOT_CONNECTED',
    isDisconnecting,
    openForm: () => {
      setIsSaved(false);
      setMode('form');
    },
    closeForm: () => setMode('view'),
    onSaved: () => {
      setIsSaved(true);
      setMode('view');
    },
    askDisconnect: () => {
      setIsSaved(false);
      setMode('confirm');
    },
    keepConnected: () => setMode('view'),
    disconnect,
  };
}
